import { Box, Paper, Divider, Typography } from "@mui/material";
import variables from "../../../../assets/styles/variables.module.scss";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ShowChartIcon from "@mui/icons-material/ShowChart";

import { useDispatch } from "react-redux";
import BaseInstance from "../../../../Services/AxiosInstance/BaseInstance";
import {
  StartLoading,
  StopLoading,
} from "../../../Store/LoadingReducer/LoaderActions";
import {
  DASHBOARD_ACTIVITY,
  DASHBOARD_AGENT,
  DASHBOARD_KNOWLEDGE_BASE,
} from "../../../../Services/Endpoint";
import { ShowError } from "../../../Store/MessageReducer/MsgActions";
import { useEffect, useState } from "react";
import { DashboardStats } from "../../../Types/Dashboard";
import { useNavigate } from 'react-router-dom';


interface MyComponentProps {
  dashboardStats:DashboardStats
}

const SmallCardConversations:React.FC<MyComponentProps> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
 
  return (
    <Paper
      onClick={() => navigate('/dashboard-analytics')}
      sx={{
        borderRadius: "12px",
        p: 3,
        display: "flex",
        flexDirection: "column",
        background: "#04db93",
        color: variables.whiteColor,
        height: "100%",
        boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
         cursor: 'pointer', 
        transition: 'all 0.2s ease-in-out', 
        '&:hover': {
          boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      {/* Header */}
      <Box display="flex" alignItems="center" mb={2}>
        <ChatBubbleOutlineIcon sx={{ mr: 1 }} />
        <Typography variant="subtitle1" fontWeight={600}>
          Conversations
        </Typography>
      </Box>

      {/* Main Count */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{
            textTransform: "uppercase",
            letterSpacing: "0.5px", // Optional: adds better spacing for uppercase text
          }}
        >
          CONVERSATIONS
        </Typography>
        <Typography variant="h4" fontWeight={700}>
         {props.dashboardStats.activity.total_conversations}
        </Typography>
      </Box>

      <Divider sx={{ backgroundColor: variables.whiteColor, my:1 }} />

      {/* Sub Info Section */}

      <Box>
        {/* Documents */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            Total Messages
          </Typography>

          <Typography variant="body2" fontWeight={600}>
            {props.dashboardStats.activity.total_messages}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            Recent Conversations
          </Typography>

          <Typography variant="body2" fontWeight={600}>
            {props.dashboardStats.activity.recent_conversations}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default SmallCardConversations;
